import OrderItem from 'types/OrderItem';
import formatCurrency from './formatCurrency';

export enum PriceLabel {
  FREE = 'free',
  REWARD = 'reward',
}

export const getPriceLabel = (isFree = false, isReward = false): string => {
  // Set Default Values
  let label = '';

  // Set Price Label
  if (isReward) {
    label = PriceLabel.REWARD;
  } else if (isFree) {
    label = PriceLabel.FREE;
  }

  // Return Price Label
  return `${label.toUpperCase()}`;
};

export const isBundleItemsAllFree = (lineItem: OrderItem): boolean => {
  return lineItem?.children?.every((item) => item?.salePrice === 0) ?? false;
};

export const getPriceToDisplay = (lineItem: OrderItem): string => {
  return !isBundleItemsAllFree(lineItem) ||
    (lineItem?.salePrice !== undefined && lineItem?.salePrice > 0)
    ? formatCurrency(lineItem?.salePrice ?? 0)
    : '';
};

export default getPriceLabel;
